import type {
  CardFooterSlots as CardFooterBaseSlots,
  CardFooterBaseProps,
  CardFooterBaseState,
} from '@fluentui/react-card';

/**
 * CardFooter component slots
 */
export type CardFooterSlots = CardFooterBaseSlots;

/**
 * CardFooter component props
 */
export type CardFooterProps = CardFooterBaseProps;

/**
 * CardFooter component state
 */
export type CardFooterState = CardFooterBaseState;
